/**
 * Floating Labels for Contact Form 7
 */
document.addEventListener('DOMContentLoaded', function() {
	const formWrapper = document.querySelector('.contact-form-wrapper');
	
	if (!formWrapper) return;
	
	// Get expand/collapse texts from data attributes
	const expandText = formWrapper.getAttribute('data-expand-text') || 'Więcej';
	const collapseText = formWrapper.getAttribute('data-collapse-text') || 'Ukryj';
	
	// Get all form field labels (direct children of form, not wrapped in span for acceptance)
	const labels = formWrapper.querySelectorAll('.wpcf7-form > label');
	
	labels.forEach(label => {
		const input = label.querySelector('input[type="text"], input[type="email"], textarea');
		
		if (!input) return;
		
		// Get label text (before the span wrapper)
		const labelTextNode = Array.from(label.childNodes).find(
			node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
		);
		
		if (labelTextNode) {
			const labelText = labelTextNode.textContent.trim();
			
			// Store original label text as data attribute
			label.setAttribute('data-label', labelText);
			
			// Create visually hidden span for screen readers
			const srOnlySpan = document.createElement('span');
			srOnlySpan.className = 'sr-only';
			srOnlySpan.textContent = labelText;
			
			// Create visible span for visual label (will be styled with CSS)
			const visualSpan = document.createElement('span');
			visualSpan.className = 'visual-label';
			visualSpan.setAttribute('aria-hidden', 'true');
			visualSpan.textContent = labelText;
			
			// Replace text node with spans
			labelTextNode.textContent = '';
			label.insertBefore(srOnlySpan, label.firstChild);
			label.insertBefore(visualSpan, label.firstChild);
			
			// Add aria-label to input as fallback
			if (!input.getAttribute('aria-label')) {
				input.setAttribute('aria-label', labelText);
			}
		}
		
		// Check if input has value on load
		function checkValue() {
			if (input.value.trim() !== '') {
				label.classList.add('has-value');
			} else {
				label.classList.remove('has-value');
			}
		}
		
		// Check on input
		input.addEventListener('input', checkValue);
		input.addEventListener('change', checkValue);
		
		// Check on load
		checkValue();
	});
	
	/**
	 * Toggle expand/collapse for long text
	 */
	function initTextToggle(element, maxLength = 150) {
		const fullText = element.textContent.trim();
		
		// Only add toggle if text is longer than maxLength
		if (fullText.length <= maxLength) return;
		
		// Find a good break point (end of sentence or word)
		let breakPoint = maxLength;
		const sentenceEnd = fullText.lastIndexOf('.', maxLength);
		const spaceEnd = fullText.lastIndexOf(' ', maxLength);
		
		if (sentenceEnd > maxLength * 0.7) {
			breakPoint = sentenceEnd + 1;
		} else if (spaceEnd > maxLength * 0.8) {
			breakPoint = spaceEnd;
		}
		
		const shortText = fullText.substring(0, breakPoint).trim() + '...';
		
		// Create toggle button
		const toggleBtn = document.createElement('button');
		toggleBtn.type = 'button';
		toggleBtn.className = 'text-toggle-btn';
		toggleBtn.textContent = expandText;
		toggleBtn.setAttribute('aria-expanded', 'false');
		
		// Wrap text in span
		const textSpan = document.createElement('span');
		textSpan.className = 'toggleable-text';
		textSpan.textContent = shortText;
		
		// Replace content
		element.textContent = '';
		element.appendChild(textSpan);
		element.appendChild(document.createTextNode(' '));
		element.appendChild(toggleBtn);
		
		// Toggle functionality
		let isExpanded = false;
		toggleBtn.addEventListener('click', function() {
			isExpanded = !isExpanded;
			
			if (isExpanded) {
				textSpan.textContent = fullText;
				toggleBtn.textContent = collapseText;
				toggleBtn.setAttribute('aria-expanded', 'true');
			} else {
				textSpan.textContent = shortText;
				toggleBtn.textContent = expandText;
				toggleBtn.setAttribute('aria-expanded', 'false');
			}
		});
	}
	
	// Apply to RODO paragraph (before acceptance checkbox)
	const rodoParagraph = formWrapper.querySelector('.wpcf7-form > p');
	if (rodoParagraph) {
		initTextToggle(rodoParagraph, 150);
	}
	
	// Apply to acceptance label text
	const acceptanceLabel = formWrapper.querySelector('.wpcf7-acceptance .wpcf7-list-item-label');
	if (acceptanceLabel) {
		initTextToggle(acceptanceLabel, 150);
	}
});
